import { devMode } from '../../../utils/coreUtils';
import { LocalStorage } from '../../../utils/storage-utils';

declare global {
	interface Window {
		fabric_data_quality: {
			locale: {
				disablePseudoLocale: () => void;
				enablePseudoLocale: () => void;
			};
			downloadLogs?: (fileName: string) => void;
		};
	}
}

export const LOCALSTORE_PSEUDO_LOCALE_ENABLE_KEY = 'fabric.locale.pseudo.enable';

/**
 * Checks if psuedo locale is enabled.
 * @returns boolean
 */
export const isPseudoLocaleEnabled = (): boolean => {
	//Enviroment variable base check and is in development mode
	const isEnabledViaEnv = import.meta.env.VITE_ENABLE_PSEUDO_LOCALE === 'true' && devMode;
	//Local storage based check
	return LocalStorage.get<boolean>(LOCALSTORE_PSEUDO_LOCALE_ENABLE_KEY) || isEnabledViaEnv;
};
